export enum SexoEnum {
    FEMININO = "Feminino",
    MASCULINO = "Masculino",
    NAO_BINARIO = "Não Binário",
    OUTRO = "Outro",
    PREFIRO_NAO_INFORMA = "Prefiro não Informar"
}